export enum RankingSortTypes {
    Rank = 0,
    Name = 1
}
